<template>
  <v-tooltip top color="primary">
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        @click="openSanad(sanad.id)"
        :class="btnClasses"
        v-bind="attrs"
        v-on="on"
        :outlined="tableStyle"
        class="mt-1 mr-1 ml-1 elevation-0 cursor-pointer rounded-lg"
        :disabled="disabled"
      >
        <v-icon class="cursor-pointer ml-2">$sanadIcon</v-icon>
        {{ sanad.code }}
      </v-btn>
    </template>
    {{ tooltip }}
  </v-tooltip>
</template>

<script>
export default {
  props: {
    sanad: {
      type: Object,
      required: true,
    },
    tableStyle: {
      default: false,
    },
    disabled: {
      default: false,
    },
    tooltip: {
      default: " مشاهده سند ",
    },
  },
  computed: {
    btnClasses() {
      if (this.tableStyle) {
      } else {
        return "primary white--text mr-1";
      }
    },
  },
  mounted() {},
  methods: {
    openSanad() {
      let routeData = this.$router.resolve({
        name: "SanadForm",
        params: {
          id: this.sanad.id,
        },
      });
      // window.open(routeData.href, "_blank");
      window.open(routeData.href);
    },
  },
};
</script>

<style>
.cursor-pointer {
  cursor: pointer;
}
</style>
